import { render, staticRenderFns } from "./CustomFieldTypeSelectorComponent.vue?vue&type=template&id=50dada8d&scoped=true&lang=pug"
import script from "./CustomFieldTypeSelectorComponent.vue?vue&type=script&lang=ts"
export * from "./CustomFieldTypeSelectorComponent.vue?vue&type=script&lang=ts"
import style0 from "./CustomFieldTypeSelectorComponent.vue?vue&type=style&index=0&id=50dada8d&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50dada8d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('50dada8d')) {
      api.createRecord('50dada8d', component.options)
    } else {
      api.reload('50dada8d', component.options)
    }
    module.hot.accept("./CustomFieldTypeSelectorComponent.vue?vue&type=template&id=50dada8d&scoped=true&lang=pug", function () {
      api.rerender('50dada8d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/customFields/CustomFieldTypeSelector/CustomFieldTypeSelectorComponent.vue"
export default component.exports